<template>
  <div class="index">
    <div class="top">
      <div class="top-con">
        <a href="https://www.lingjiang.com/" target="_blank" class="logo-con">
          <img src="https://oss.lingjiang.com/images/official/commonly/logo-new-v0314.png" class="logo" />
          <img src="//staticdn.lingjiang.com/webstatic/images/lingjiang/logo-text.png" class="logo-text">
        </a>
        <div class="topfont">
          <div class="top-nav">
            <a class="nav-item" v-for="nav in navList" :key="nav.name" :href="nav.linkUrl" target="_blank">{{ nav.name
            }}</a>
          </div>
          <span v-if="!userId" class="login-btn" @click="fnShowLogin">登录/注册</span>
          <p v-else>
            <img :src="analysisImgUrl(userImg)" @error="setDefaultImage">
            <span>{{ userPhone }} </span>
            <i class="logout" @click="fnLogout">退出</i>
          </p>
        </div>
      </div>
    </div>
    <div class="banner">
      <div class="step-wrap">
        <div class="step-con">
          <div class="step-item">
            <div class="step-num">01</div>
            <div class="step-title">预约报名</div>
            <div class="step-text">
              上午场:5月26日12:00前<br>下午场:5月26日17:00前
            </div>
            <div class="step-btn" @click="fnStepCick('SCENCE-CON')">立即预约</div>
          </div>
          <div class="step-item">
            <div class="step-num">02</div>
            <div class="step-title">考试答题</div>
            <div class="step-text">
              5月26日 09:00-12:00<br>5月26日 14:00-17:00
            </div>
            <div class="step-btn" @click="fnStepCick('SCENCE-CON')">进入考场</div>
          </div>
          <div class="step-item">
            <div class="step-num">03</div>
            <div class="step-title">查看答案</div>
            <div class="step-text">
              5月26日18:00
            </div>
            <div class="step-btn step-btn2" @click="fnStepCick('SCENCE-CON')">查看答案</div>
          </div>
          <div class="step-item">
            <div class="step-num">04</div>
            <div class="step-title">答案解析</div>
            <div class="step-text">
              5月27日19:00-20:30
            </div>
            <div class="step-btn step-btn2" @click="fnStepCick('LIVE-CON')">观看直播</div>
          </div>
          <div class="step-live-bg">
            <img src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gj/liveewm.png">
            <span>微信扫一扫<br>观看答案解析直播</span>
          </div>
        </div>
      </div>
    </div>

    <div class="maintitle" style="margin-top: -239px;" id="SCENCE-CON">
      <img src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gk/left.png" />考试场次安排<img
        src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gk/right.png" />
    </div>

    <div
      class="ksap"
      v-for="(item, index) in scencsList.morningSession"
      v-if="index == selectMorningIndex"
    >
      <div class="ksaptop">
        <div class="ksaptoptag">
          <div class="ksaptitle">上午场</div>
          {{ item.strTime }}
        </div>
        <div class="tags" v-for="(tag, tagIndex) in scencsList.morningSession">
          <span
            :class="selectMorningIndex == tagIndex ? 'activeTag' : ''"
            @click="fnSelectMorningIndex(tagIndex)"
            >{{ tag.subjectName }} <i class="line" v-if="selectMorningIndex == tagIndex"></i></span
          >
        </div>
      </div>
      <div class="pad30">
        <div class="ksapbg">
          <div class="mktitle">
            <span class="mktitlefont">{{ item.paperName }}</span>
          </div>
          <div class="mkicon">
            <ul>
              <li>全真模拟国家考试</li>
              <li>牛师命题试卷</li>
              <li>优师直播逐题讲解</li>
            </ul>
          </div>
          <div class="mkdesc">
            考试时长：180分钟<br />
            考试时间：{{
              item.beginTime.substring(0, item.beginTime.length - 3)
            }}至{{
              item.endTime.substring(
                item.endTime.length - 8,
                item.endTime.length - 3
              )
            }}<br />
            <span>答案开放时间：5月26日18:00</span>
          </div>
          <img
            :src="
              Date.parse(item.endTime.replace(/-/g, '/')) < nowDateNum
                ? bmend
                : item.appointment
                ? bmok
                : ''
            "
            class="mkstatus"
          />
          <a
            href="javascript:void(0)"
            @click="fnAppointment(item, 1)"
            class="enterbtn transition4"
            v-if="
              !item.appointment &&
              nowDateNum < Date.parse(item.endTime.replace(/-/g, '/'))
            "
            >立即预约</a
          >
          <a
            href="javascript:void(0)"
            v-if="
              item.appointment &&
              nowDateNum < Date.parse(item.endTime.replace(/-/g, '/'))
            "
            @click="enterExam(item, index)"
            class="enterbtn transition4"
            >进入考场</a
          >
          <a
            href="javascript:void(0)"
            class="lookbtn transition4"
            @click="checkAnswer(item)"
            >查看答案</a
          >
        </div>
      </div>
    </div>
    <div
      class="ksap"
      v-for="(item, index) in scencsList.afternoonSession"
      v-if="index == selectAfternoonIndex"
    >
      <div class="ksaptop">
        <div class="ksaptoptag">
          <div class="ksaptitle">下午场</div>
          {{ item.strTime }}
        </div>
        <div
          class="tags"
          v-for="(tag, tagIndex) in scencsList.afternoonSession"
        >
          <span
            :class="selectAfternoonIndex == tagIndex ? 'activeTag' : ''"
            @click="fnSelectAfternoonIndex(tagIndex)"
            >{{ tag.subjectName }} <i class="line" v-if="selectAfternoonIndex == tagIndex"></i></span
          >
        </div>
      </div>
      <div class="pad30">
        <div class="ksapbg">
          <div class="mktitle">
            <span class="mktitlefont">{{ item.paperName }}</span>
          </div>
          <div class="mkicon">
            <ul>
              <li>全真模拟国家考试</li>
              <li>牛师命题试卷</li>
              <li>优师直播逐题讲解</li>
            </ul>
          </div>
          <div class="mkdesc">
            考试时长：180分钟<br />
            考试时间：{{
              item.beginTime.substring(0, item.beginTime.length - 3)
            }}至{{
              item.endTime.substring(
                item.endTime.length - 8,
                item.endTime.length - 3
              )
            }}<br />
            <span>答案开放时间：5月26日18:00</span>
          </div>
          <img
            :src="
              Date.parse(item.endTime.replace(/-/g, '/')) < nowDateNum
                ? bmend
                : item.appointment
                ? bmok
                : ''
            "
            class="mkstatus"
          />
          <a
            href="javascript:void(0)"
            @click="fnAppointment(item, 2)"
            class="enterbtn transition4"
            v-if="
              !item.appointment &&
              nowDateNum < Date.parse(item.endTime.replace(/-/g, '/'))
            "
            >立即预约</a
          >
          <a
            href="javascript:void(0)"
            v-if="
              item.appointment &&
              nowDateNum < Date.parse(item.endTime.replace(/-/g, '/'))
            "
            @click="enterExam(item, index)"
            class="enterbtn transition4"
            >进入考场</a
          >
          <a
            href="javascript:void(0)"
            class="lookbtn transition4"
            @click="checkAnswer(item)"
            >查看答案</a
          >
        </div>
      </div>
    </div>

    <div class="ksap-remark">
      <div class="title">考试说明：</div>
      <div class="remark-text">1.全真模拟考试只能在电脑上答题，<span @click="fnDownloadChrome">推荐您使用最新版谷歌浏览器（点击下载）</span>或将360浏览器切换至极速模式。</div>
      <div class="remark-text">2.在考试中，考试如果中断，考生可以从报名页面点击“进入考场”重新进入。</div>
      <div class="remark-text">3.<span @click="checkPc">电脑配置是否符合考试要求(点击检查)</span>。</div>
      <img src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gj/ksap-remark.png">
    </div>

    <div class="livebg ksap" id="LIVE-CON">
      <div class="ksaptop">
        <div class="ksaptoptag">
          <div class="ksaptitle" style="line-height: 67px">直播讲解</div>
        </div>
        <div
          class="tags"
          v-for="(tag, tagIndex) in scencsList.afternoonSession"
        >
          <span
            :class="actindexLivename == tag.subjectName ? 'activeTag' : ''"
            @click="livebtnClick(tag.subjectName)"
            >{{ tag.subjectName }}<i class="line" v-if="actindexLivename == tag.subjectName"></i></span
          >
        </div>
      </div>
      <div class="w1200 live">
        <div v-if="actindexLivename == '工商管理'" class="liveplay" :key="1">
          <img
            src="https://oss.lingjiang.com/webstatic/questionbank/images/mock-exam/2023/gjjjs/xz.png"
          />
          <div class="livemain">
            <div style="width: 61%">
              <div
                v-if="
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                  'timeline2'
                "
                class="livetitle"
              >
                直播进行中
              </div>
              <div
                v-if="
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                  'timeline1'
                "
                class="livetitle"
              >
                直播已结束
              </div>
              <div
                v-if="
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                  'timeline3'
                "
                class="livetitle"
              >
                直播未开始
              </div>
              <div class="livedesc">
                <div>
                  <span>直播时间：2024-05-27 19:00-20:30</span>
                  <span>直播讲师：徐志</span>
                </div>
              </div>
              <a
                v-if="
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                    'timeline2' ||
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                    'timeline1'
                "
                href="javascript:void(0)"
                @click="
                  fnLiveClick(
                    '//mis1.lingjiang.com/html_pc/live_free/m/?id=1576&RegNID=3090&ChannelSource=4'
                  )
                "
                class="looklive"
                >{{
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                  'timeline2'
                    ? '观看直播'
                    : '观看回放'
                }}</a
              >
            </div>
          </div>
        </div>
        <div v-if="actindexLivename == '财政税收'" class="liveplay" :key="2">
          <img
            src="https://oss.lingjiang.com/webstatic/questionbank/images/mock-exam/2023/gjjjs/cpp.png"
          />
          <div class="livemain">
            <div style="width: 61%">
              <div
                v-if="
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                  'timeline2'
                "
                class="livetitle"
              >
                直播进行中
              </div>
              <div
                v-if="
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                  'timeline1'
                "
                class="livetitle"
              >
                直播已结束
              </div>
              <div
                v-if="
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                  'timeline3'
                "
                class="livetitle"
              >
                直播未开始
              </div>
              <div class="livedesc">
                <div>
                  <span>直播时间：2024-05-27 19:00-20:30</span>
                  <span>直播讲师：常盼盼</span>
                </div>
              </div>
              <a
                v-if="
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                    'timeline2' ||
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                    'timeline1'
                "
                href="javascript:void(0)"
                @click="
                  fnLiveClick(
                    '//mis1.lingjiang.com/html_pc/live_free/m/?id=1575&RegNID=3089&ChannelSource=4'
                  )
                "
                class="looklive"
                >{{
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                  'timeline2'
                    ? '观看直播'
                    : '观看回放'
                }}</a
              >
            </div>
          </div>
        </div>
        <div v-if="actindexLivename == '金融'" class="liveplay" :key="3">
          <img
            src="https://oss.lingjiang.com/webstatic/questionbank/images/mock-exam/2023/gjjjs/wr.png"
          />
          <div class="livemain">
            <div style="width: 61%">
              <div
                v-if="
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                  'timeline2'
                "
                class="livetitle"
              >
                直播进行中
              </div>
              <div
                v-if="
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                  'timeline1'
                "
                class="livetitle"
              >
                直播已结束
              </div>
              <div
                v-if="
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                  'timeline3'
                "
                class="livetitle"
              >
                直播未开始
              </div>
              <div class="livedesc">
                <div>
                  <span>直播时间：2024-05-27 19:00-20:30</span>
                  <span>直播讲师：王锐</span>
                </div>
              </div>
              <a
                v-if="
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                    'timeline2' ||
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                    'timeline1'
                "
                href="javascript:void(0)"
                @click="
                  fnLiveClick(
                    '//mis1.lingjiang.com/html_pc/live_free/m/?id=1573&RegNID=3087&ChannelSource=4'
                  )
                "
                class="looklive"
                >{{
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                  'timeline2'
                    ? '观看直播'
                    : '观看回放'
                }}</a
              >
            </div>
          </div>
        </div>
        <div v-if="actindexLivename == '人力资源' || actindexLivename == '人力资源管理'" class="liveplay" :key="4">
          <img
            src="https://oss.lingjiang.com/webstatic/questionbank/images/mock-exam/2023/gjjjs/fsf.png"
          />
          <div class="livemain">
            <div style="width: 61%">
              <div
                v-if="
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                  'timeline2'
                "
                class="livetitle"
              >
                直播进行中
              </div>
              <div
                v-if="
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                  'timeline1'
                "
                class="livetitle"
              >
                直播已结束
              </div>
              <div
                v-if="
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                  'timeline3'
                "
                class="livetitle"
              >
                直播未开始
              </div>
              <div class="livedesc">
                <div>
                  <span>直播时间：2024-05-27 19:00-20:30</span>
                  <span>直播讲师：费善峰</span>
                </div>
              </div>
              <a
                v-if="
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                    'timeline2' ||
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                    'timeline1'
                "
                href="javascript:void(0)"
                @click="
                  fnLiveClick(
                    '//mis1.lingjiang.com/html_pc/live_free/m/?id=1577&RegNID=3091&ChannelSource=4'
                  )
                "
                class="looklive"
                >{{
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                  'timeline2'
                    ? '观看直播'
                    : '观看回放'
                }}</a
              >
            </div>
          </div>
        </div>
        <div v-if="actindexLivename == '农业经济'" class="liveplay" :key="5">
          <img
            src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gj/zll.png"
          />
          <div class="livemain">
            <div style="width: 61%">
              <div
                v-if="
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                  'timeline2'
                "
                class="livetitle"
              >
                直播进行中
              </div>
              <div
                v-if="
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                  'timeline1'
                "
                class="livetitle"
              >
                直播已结束
              </div>
              <div
                v-if="
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                  'timeline3'
                "
                class="livetitle"
              >
                直播未开始
              </div>
              <div class="livedesc">
                <div>
                  <span>直播时间：2024-05-27 19:00-20:30</span>
                  <span>直播讲师：张璐璐</span>
                </div>
              </div>
              <a
                v-if="
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                    'timeline2' ||
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                    'timeline1'
                "
                href="javascript:void(0)"
                @click="
                  fnLiveClick(
                    '//mis1.lingjiang.com/html_pc/live_free/m/?id=1578&RegNID=3092&ChannelSource=4'
                  )
                "
                class="looklive"
                >{{
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                  'timeline2'
                    ? '观看直播'
                    : '观看回放'
                }}</a
              >
            </div>
          </div>
        </div>
        <div v-if="actindexLivename == '建筑与房地产经济'" class="liveplay" :key="6">
          <img
            src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gj/cab.png"
          />
          <div class="livemain">
            <div style="width: 61%">
              <div
                v-if="
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                  'timeline2'
                "
                class="livetitle"
              >
                直播进行中
              </div>
              <div
                v-if="
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                  'timeline1'
                "
                class="livetitle"
              >
                直播已结束
              </div>
              <div
                v-if="
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                  'timeline3'
                "
                class="livetitle"
              >
                直播未开始
              </div>
              <div class="livedesc">
                <div>
                  <span>直播时间：2024-05-27 19:00-20:30</span>
                  <span>直播讲师：崔啊波</span>
                </div>
              </div>
              <a
                v-if="
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                    'timeline2' ||
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                    'timeline1'
                "
                href="javascript:void(0)"
                @click="
                  fnLiveClick(
                    '//mis1.lingjiang.com/html_pc/live_free/m/?id=1574&RegNID=3088&ChannelSource=4'
                  )
                "
                class="looklive"
                >{{
                  checkTime('2024/05/27 19:00:00', '2024/05/27 20:30:00') ==
                  'timeline2'
                    ? '观看直播'
                    : '观看回放'
                }}</a
              >
            </div>
          </div>
        </div>
        <div class="ewm">
          <img src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gj/liveewm.png" /><br />
          扫码关注后<br />直播前一天提醒
        </div>
      </div>
    </div>

    <div class="maintitle">
      <img src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gk/left.png" />课程介绍<img
        src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gk/right.png" />
    </div>
    <div class="w1200">
      <div class="tabs">
        <span
          class="item"
          v-for="(item, index) in kclist"
          :key="index"
          :class="{ active: kcindex == index }"
          @click="tabclick(index)"
          >{{ item.title }}</span
        >
      </div>
      <div
        class="bluebg"
        v-for="(item, index) in kclist"
        :key="index"
        v-if="kcindex == index"
      >
        <div class="kcSubject" v-if="kcindex == 0 || kcindex == 3">
          <p v-for="(subjectItem, subjectIndex) in scencsList.afternoonSession" :class="kcSubjectId == subjectItem.subjectId ? 'active' : ''" :key="subjectIndex" @click="kcSubjectClick(subjectItem)"> {{ subjectItem.subjectName }}</p>
        </div>
        <div v-if="kcindex == 0 || kcindex == 3">
          <div class="kcmain" v-for="(val, index2) in item.kc.filter(course => course.subjectId == kcSubjectId)" :key="index2">
            <div class="kcname">{{ val.name }}</div>
            <div class="kcbuy">
              <div class="price">
                ￥<strong>{{ val.price }}</strong>
              </div>
              <a :href="val.url" target="_blank" class="buybtn">了解课程详情</a>
            </div>
            <div class="kcright">
              <div class="kcdiv1">
                <div class="kctitle">经典课程</div>
                <ul>
                  <li v-for="k in val.jdkc">{{ k }}</li>
                </ul>
              </div>
              <div class="kcdiv2">
                <div class="kctitle">特色服务</div>
                <ul>
                  <li v-for="k in val.tsfw">{{ k }}</li>
                </ul>
              </div>
              <div class="kcdiv3">
                <div class="kctitle">学习资料</div>
                <ul>
                  <li v-for="k in val.xxzl">{{ k }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div v-if="kcindex == 1 || kcindex == 2">
          <div class="kcmain" v-for="(val, index2) in item.kc" :key="index2">
            <div class="kcname">{{ val.name }}</div>
            <div class="kcbuy">
              <div class="price">
                ￥<strong>{{ val.price }}</strong>
              </div>
              <a :href="val.url" target="_blank" class="buybtn">了解课程详情</a>
            </div>
            <div class="kcright">
              <div class="kcdiv1">
                <div class="kctitle">经典课程</div>
                <ul>
                  <li v-for="k in val.jdkc">{{ k }}</li>
                </ul>
              </div>
              <div class="kcdiv2">
                <div class="kctitle">特色服务</div>
                <ul>
                  <li v-for="k in val.tsfw">{{ k }}</li>
                </ul>
              </div>
              <div class="kcdiv3">
                <div class="kctitle">学习资料</div>
                <ul>
                  <li v-for="k in val.xxzl">{{ k }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <Footer />

    <div v-if="isShowWebkit" class="mask" @touchmove.prevent.stop @mousewheel.prevent>
      <div class="modalcen">
        <div class="modalicon"><img src="../assets/lingdang.png" /></div>
        <div class="modaltitle">温馨提示</div>
        <div class="modalfont">
          您当前使用的浏览器模式暂不能很好的支持题库答题，若您使用360/QQ浏览器，请切换为极速模式，请下载
          Chrome浏览器。<a href="https://www.google.cn/chrome/" target="_blank">点击此处下载谷歌 Chrome 浏览器</a>
        </div>
      </div>
    </div>

    <div v-if="isWeChat" class="mask" @touchmove.prevent.stop @mousewheel.prevent>
      <div class="modalcen">
        <div class="modalicon"><img src="../assets/lingdang.png" /></div>
        <div class="modaltitle">温馨提示</div>
        <div class="wxTips">
          <p>微信中不支持答题</p>
          <p>请复制下面链接，粘贴在浏览器（谷歌、360极速版）中，再进行答题。</p>
          <p class="linkInfo"><span id="text">https://www.lingjiang.com/</span><span @click="copyText">复制链接</span></p>
        </div>
        <div class="modalbtngroup transition4" @click="isWeChat = false">我知道了</div>
      </div>
      <textarea id="input" style="opacity: 0 !important">这是幕后黑手</textarea>
    </div>

    <div v-if="showPcTip" class="mask" @touchmove.prevent.stop @mousewheel.prevent>
      <div class="modalcen">
        <div class="modalicon"><img src="../assets/lingdang.png" /></div>
        <div class="modaltitle">温馨提示</div>
        <div class="modalfont fexdiv" v-if="isWebkit">
          <img src="../assets/duihao.png" />您当前的浏览器支持本次考试
        </div>
        <div class="modalfont fexdiv" v-if="isWebkit == false">
          <img src="../assets/tanhao.png" />您当前的浏览器不支持本次考试
        </div>
        <div class="modalfont fexdiv" v-if="screenArry[0] < 1920">
          <img src="../assets/tanhao.png" />
          <div>
            您当前电脑显示器分辨率过低({{ screenArry[0] }}*{{
              screenArry[1]
            }}),会影响做题体验。<span class="modaltip">建议您在考试时选择合适的电脑或调整显示的分辨率（要求不低于1920×1080）</span>
          </div>
        </div>
        <div class="modalfont fexdiv" v-else>
          <img src="../assets/duihao.png" />您当前电脑显示器分辨率支持本次考试
        </div>
        <div class="modalbtngroup transition4" @click="showPcTip = false">我知道了</div>
      </div>
    </div>

    <div class="fukuang">
      <a href="javascript:;" onclick="openchat()"><img src="../assets/fk1.png" alt="" style="width: 25px;" />
        <p>问题咨询</p>
        <div class="line"></div>
      </a>
      <a href="javascript:;"><img src="../assets/fk2.png" alt="" style="width: 35px;" />
        <p>高经干货</p>
        <div class="line"></div>
        <span class="zixunhover" style="padding: 5px 0 10px 0;"><img
            src="https://oss.lingjiang.com/webstatic/questionbank/images/mock-exam/2023/wx_gaojing.jpg" style="width: 140px; height: 140px"/>
          <div>扫码回复"备考"</div>
          <div>领取"高经干货"</div>
        </span>
      </a>
      <a href="javascript:;"><img src="../assets/fk3.png" alt="" style="width: 30px;" />
        <p>优师答疑</p>
        <div class="line"></div>
        <span class="zixunhover zixunhover1">微信扫码，免费提问<br />
          <img src="https://oss.lingjiang.com/webstatic/questionbank/images/mock-exam/2023/xcx.08842836.jpg"
            style="width: 140px; height: 140px" />上领匠问答，<br />给你靠谱回答！</span>
      </a>
      <div @click="fnBackTop" class="back-top">Top</div>
    </div>

    <!-- 预约成功弹窗 -->
    <div v-if="modaldivAppoint" class="mask" @touchmove.prevent.stop @mousewheel.prevent>
      <div class="modalcen modalcen3">
        <div class="modalicon"><img src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gj/success.png" />
        </div>
        <div class="modaltitle" style="color: #0aca4c; padding-top: 14px;">预约成功</div>
        <div class="modalfont modalfont-flex">
          <img class="live-ewm" src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gj/liveewm.png">
          <div class="modalfont-text">
            <span>微信扫一扫</span>
            <span>观看答案解析直播</span>
            <span style="color: red; margin-top: 15px;">点击进入考场</span>
            <span style="color: red">快去答题吧~</span>
          </div>
        </div>
        <div class="modalbtngroup2 modalbtngroup3" style="overflow: visible;">
          <div class="modalbtn1 transition4" @click="modaldivAppoint = false">我知道了</div>
        </div>
      </div>
    </div>

    <!-- 二次确认弹窗 -->
    <div v-if="modaldiv" class="mask" @touchmove.prevent.stop @mousewheel.prevent>
      <div class="modalcen modalcen2">
        <div class="modalicon"><img src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gk/warning.png" />
        </div>
        <div class="modaltitle" style="color: red; padding-top: 14px;">重要提示</div>
        <div class="modalfont">
          <span style="color: red;">两场考试试卷相同</span>，参加一场就可以啦。<br />
          还想继续预约吗？
        </div>
        <div class="modalbtngroup2" style="overflow: visible;">
          <div class="modalbtn1 transition4" @click="modaldiv = false">取消</div>
          <div class="modalbtn2 transition4" @click="fnConfirmAppointment">确认预约</div>
        </div>
      </div>
    </div>

    <div class="review" v-if="bshowReview">
      <img src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gj/review-bg.png?v=1.1" @click="fnGoReview()" class="review-bg">
      <img src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gj/review-btn.png" @click="fnGoReview()" class="review-btn">
      <img src="../assets/close-review.png" class="close-review-img" @click="bshowReview = false">
    </div>

    <!-- 登录弹框 -->
    <div class="mask" v-show="isShowLogin">
      <div class="login">
        <div class="login-title">登录/注册</div>
        <div class="login-form-main-con">
          <div class="form-item phone">
            <input v-model="checkPhone" oninput="value=value.replace(/[^\d]/g,'').slice(0,11)" placeholder="请输入您的手机号"
              maxlength="11" />
          </div>
          <div class="form-item code">
            <input v-model="checkNum" oninput="value=value.replace(/[^\d]/g,'').slice(0,4)" placeholder="请输入短信验证码"
              maxlength="4" />
            <div class="checkNumBtn" @click="getCheckNum" :style="{opacity: checkNumText === '获取验证码' ? '1' :' 0.4', cursor: checkNumText === '获取验证码' ? 'pointer' : 'not-allowed'}">
              {{ checkNumText }}
            </div>
          </div>
        </div>
        <span class="tips">未注册过的手机号将自动创建账号</span>
        <div class="login-btn" @click="submit">登录</div>
        <img src="../assets/icon-close.png" class="close-btn" @click="hideLogin" />
      </div>
    </div>
  </div>
</template>

<script>
var code = 'gjjjsqzmn2024';
var examuserUrl = '//questionbank.lingjiang.com'; // 题库链接  //questionbank.lingjiang.com  //questionbank-test.lingjiang.com
import * as api from '../api/api.js';
const headImg = 'https://oss.lingjiang.com/webstatic/images/lingjiang/new-default-headimg.png'
import Footer from '@/components/footer.vue';
export default {
  components: {
    Footer,
  },
  data() {
    return {
      selectScensInfo: {}, // 当前选中的场次信息
      bmend: require('../assets/bmend.png'),
      bmok: require('../assets/bmok.png'),
      userId: '',
      userPhone: '',
      username: '',
      userImg: '',
      RegNID: '3107', //方案id
      ChannelSource: '',
      navList: [
        { name: '选课中心', linkUrl: 'https://www.lingjiang.com/products' },
        { name: '试听课', linkUrl: 'https://www.lingjiang.com/listens' },
        { name: '评审专题', linkUrl: 'https://www.lingjiang.com/spread/review/2023/topic/index.html#/?Project=38' },
      ],
      isShowLogin: false,
      checkNum: '',
      checkPhone: '',
      checkNumText: '获取验证码',
      timer: null,
      logonBtnDisabled1: false,
      logonBtnDisabled2: false,
      projectId: 38,

      scencsList: [], //场次数据
      modaldiv: false,
      selectMorningIndex: 0,
      selectAfternoonIndex: 0,
      scencsType: 1,

      actindexLivename: '工商管理',

      isShowWebkit: false,
      isWebkit: true,
      showPcTip: false,
      screenArry: [],
      kcindex: 0,

      kclist: [
        {
          title: '课程',
          kc: [
            {
              subjectId: '80',
              name: '优学特训班2学期',
              price: '4080',
              jdkc: ['先修预习', '基础点拨', '习题特训', '时政热点', '冲刺串讲', '模考点评', '考前点睛'],
              tsfw: ['答疑板答疑', '无纸化题库', '免费重读'],
              xxzl: [
                '历年考题（题库版）',
                '章节练习（题库版）',
                '考前模拟卷（2套）',
                '学习计划',
                '课程讲义（电子版）',
                '《历年考题》（纸质版）',
                '助学资料包'
              ],
              url: 'https://www.lingjiang.com/product/2788?type=class',
            },
            {
              subjectId: '22',
              name: '优学特训班2学期',
              price: '4080',
              jdkc: ['先修预习', '基础点拨', '习题特训', '时政热点', '冲刺串讲', '模考点评', '考前点睛'],
              tsfw: ['答疑板答疑', '无纸化题库', '免费重读'],
              xxzl: [
                '历年考题（题库版）',
                '章节练习（题库版）',
                '考前模拟卷（2套）',
                '学习计划',
                '课程讲义（电子版）',
                '《历年考题》（纸质版）',
                '助学资料包'
              ],
              url: 'https://www.lingjiang.com/product/2789?type=class',
            },
            {
              subjectId: '82',
              name: '优学特训班2学期',
              price: '4080',
              jdkc: ['先修预习', '基础点拨', '习题特训', '时政热点', '冲刺串讲', '模考点评', '考前点睛'],
              tsfw: ['答疑板答疑', '无纸化题库', '免费重读'],
              xxzl: [
                '历年考题（题库版）',
                '章节练习（题库版）',
                '考前模拟卷（2套）',
                '学习计划',
                '课程讲义（电子版）',
                '《历年考题》（纸质版）',
                '助学资料包'
              ],
              url: 'https://www.lingjiang.com/product/2791?type=class',
            },
            {
              subjectId: '81',
              name: '优学特训班2学期',
              price: '4080',
              jdkc: ['先修预习', '基础点拨', '习题特训', '时政热点', '冲刺串讲', '模考点评', '考前点睛'],
              tsfw: ['答疑板答疑', '无纸化题库', '免费重读'],
              xxzl: [
                '历年考题（题库版）',
                '章节练习（题库版）',
                '考前模拟卷（2套）',
                '学习计划',
                '课程讲义（电子版）',
                '《历年考题》（纸质版）',
                '助学资料包'
              ],
              url: 'https://www.lingjiang.com/product/2787?type=class',
            },
            {
              subjectId: '147',
              name: '优学特训班2学期',
              price: '4080',
              jdkc: ['先修预习', '基础点拨', '习题特训', '时政热点', '冲刺串讲', '模考点评', '考前点睛'],
              tsfw: ['答疑板答疑', '无纸化题库', '免费重读'],
              xxzl: [
                '历年考题（题库版）',
                '章节练习（题库版）',
                '考前模拟卷（2套）',
                '学习计划',
                '课程讲义（电子版）',
                '《历年考题》（纸质版）',
                '助学资料包'
              ],
              url: 'https://www.lingjiang.com/product/2790?type=class',
            },
            {
              subjectId: '175',
              name: '优学特训班2学期',
              price: '4080',
              jdkc: ['先修预习', '基础点拨', '习题特训', '时政热点', '冲刺串讲', '模考点评', '考前点睛'],
              tsfw: ['答疑板答疑', '无纸化题库', '免费重读'],
              xxzl: [
                '历年考题（题库版）',
                '章节练习（题库版）',
                '考前模拟卷（2套）',
                '学习计划',
                '课程讲义（电子版）',
                '《历年考题》（纸质版）',
                '助学资料包'
              ],
              url: 'https://www.lingjiang.com/product/2916?type=class',
            },



            {
              subjectId: '80',
              name: '督学特训班2学期',
              price: '4580',
              jdkc: ['先修预习', '基础点拨', '习题特训', '时政热点', '冲刺串讲', '模考点评', '论文辅导', '评审辅导'],
              tsfw: ['答疑板答疑', '无纸化题库', '班主任1V1', '月度回访', '进度追踪', '节点通知', '报考答疑', '免费重读'],
              xxzl: [
                '入学测试（题库版）',
                '历年考题（题库版）',
                '章节练习（题库版）',
                '考前模拟卷（2套）',
                '备考建议',
                '课程讲义（电子版）',
                '《历年考题》（纸质版）',
                '备考资料包',
              ],
              url: 'https://www.lingjiang.com/product/2798?type=class',
            },
            {
              subjectId: '22',
              name: '督学特训班2学期',
              price: '4580',
              jdkc: ['先修预习', '基础点拨', '习题特训', '时政热点', '冲刺串讲', '模考点评', '论文辅导', '评审辅导'],
              tsfw: ['答疑板答疑', '无纸化题库', '班主任1V1', '月度回访', '进度追踪', '节点通知', '报考答疑', '免费重读'],
              xxzl: [
                '入学测试（题库版）',
                '历年考题（题库版）',
                '章节练习（题库版）',
                '考前模拟卷（2套）',
                '备考建议',
                '课程讲义（电子版）',
                '《历年考题》（纸质版）',
                '备考资料包',
              ],
              url: 'https://www.lingjiang.com/product/2799?type=class',
            },
            {
              subjectId: '82',
              name: '督学特训班2学期',
              price: '4580',
              jdkc: ['先修预习', '基础点拨', '习题特训', '时政热点', '冲刺串讲', '模考点评', '论文辅导', '评审辅导'],
              tsfw: ['答疑板答疑', '无纸化题库', '班主任1V1', '月度回访', '进度追踪', '节点通知', '报考答疑', '免费重读'],
              xxzl: [
                '入学测试（题库版）',
                '历年考题（题库版）',
                '章节练习（题库版）',
                '考前模拟卷（2套）',
                '备考建议',
                '课程讲义（电子版）',
                '《历年考题》（纸质版）',
                '备考资料包',
              ],
              url: 'https://www.lingjiang.com/product/2801?type=class',
            },
            {
              subjectId: '81',
              name: '督学特训班2学期',
              price: '4580',
              jdkc: ['先修预习', '基础点拨', '习题特训', '时政热点', '冲刺串讲', '模考点评', '论文辅导', '评审辅导'],
              tsfw: ['答疑板答疑', '无纸化题库', '班主任1V1', '月度回访', '进度追踪', '节点通知', '报考答疑', '免费重读'],
              xxzl: [
                '入学测试（题库版）',
                '历年考题（题库版）',
                '章节练习（题库版）',
                '考前模拟卷（2套）',
                '备考建议',
                '课程讲义（电子版）',
                '《历年考题》（纸质版）',
                '备考资料包',
              ],
              url: 'https://www.lingjiang.com/product/2797?type=class',
            },
            {
              subjectId: '147',
              name: '督学特训班2学期',
              price: '4580',
              jdkc: ['先修预习', '基础点拨', '习题特训', '时政热点', '冲刺串讲', '模考点评', '论文辅导', '评审辅导'],
              tsfw: ['答疑板答疑', '无纸化题库', '班主任1V1', '月度回访', '进度追踪', '节点通知', '报考答疑', '免费重读'],
              xxzl: [
                '入学测试（题库版）',
                '历年考题（题库版）',
                '章节练习（题库版）',
                '考前模拟卷（2套）',
                '备考建议',
                '课程讲义（电子版）',
                '《历年考题》（纸质版）',
                '备考资料包',
              ],
              url: 'https://www.lingjiang.com/product/2800?type=class',
            },
            {
              subjectId: '175',
              name: '督学特训班2学期',
              price: '4580',
              jdkc: ['先修预习', '基础点拨', '习题特训', '时政热点', '冲刺串讲', '模考点评', '论文辅导', '评审辅导'],
              tsfw: ['答疑板答疑', '无纸化题库', '班主任1V1', '月度回访', '进度追踪', '节点通知', '报考答疑', '免费重读'],
              xxzl: [
                '入学测试（题库版）',
                '历年考题（题库版）',
                '章节练习（题库版）',
                '考前模拟卷（2套）',
                '备考建议',
                '课程讲义（电子版）',
                '《历年考题》（纸质版）',
                '备考资料包',
              ],
              url: 'https://www.lingjiang.com/product/2914?type=class',
            },
          ],
        },
        {
          title: '论文辅导班',
          kc: [
            {
              name: '精品论文班',
              price: '8000',
              jdkc: ['评审论文指导课', '论文写作指导课'],
              tsfw: [
                '1V1建立服务',
                '个性化选题指导',
                '论文写作优化指导',
                '双刊号期刊推荐发表',
                '评审论文申报材料',
                '专属期刊渠道',
              ],
              xxzl: ['杂志社样刊（1-2本）', '查重报告', '论文检索页'],
              url: 'https://www.lingjiang.com/product/3061?type=class',
            },
            {
              name: '高端论文班',
              price: '9800',
              jdkc: ['评审论文指导课', '论文写作指导课'],
              tsfw: [
                '1V1建立服务',
                '论文指导优选课程',
                '个性化选题指导',
                '论文写作优化指导',
                '评审论文申报材料'
              ],
              xxzl: ['论文大纲撰写指导', '知网全文收录', '专业学术期刊推荐发表', '杂志社样刊（1-2本）', '查重报告', '论文检索页'],
              url: 'https://www.lingjiang.com/product/3058?type=class',
            },
          ],
        },
        {
          title: '评审指导班',
          kc: [
            {
              name: '评审指导班',
              price: '8999',
              jdkc: ['业绩优化指导课', '评审指导课程', '优质答辩课程'],
              tsfw: [
                '1v1评审指导服务',
                '业绩优化润色指导',
                '评审申报指导',
                '评审问题专业答疑',
                '评审指导手册',
              ],
              xxzl: [
                '1V1学员服务',
                '业绩亮点挖掘',
                '评审申报指导',
                '佐证材料筹备方案',
                '填报系统操作指南',
                '材料装订指导手册',
                '答辩注意事项汇编',
                '评审自我介绍模板',
              ],
              url: 'https://www.lingjiang.com/product/3008?type=class',
            },
            {
              name: '模拟答辩班 | 陈鹤',
              price: '6999',
              jdkc: ['模拟答辩指导课', '答辩答疑直播'],
              tsfw: [
                '优师1V1面试指导',
                '量身模拟答辩问题',
                '通性问题答疑',
                '针对性点评',
                '答辩技巧补充',
              ],
              xxzl: [
                '优师1v1面试指导',
                '量身模拟答辩问题',
                '通性问题答疑',
                '针对性点评',
                '答辩技巧补充',
                '答辩自我介绍模板'
              ],
              url: 'https://www.lingjiang.com/product/3011?type=class',
            },
            {
              name: '模拟答辩班 | 韩新宽',
              price: '6999',
              jdkc: ['模拟答辩指导课', '答辩答疑直播'],
              tsfw: [
                '优师1V1面试指导',
                '量身模拟答辩问题',
                '通性问题答疑',
                '针对性点评',
                '答辩技巧补充',
              ],
              xxzl: [
                '优师1v1面试指导',
                '量身模拟答辩问题',
                '通性问题答疑',
                '针对性点评',
                '答辩技巧补充',
                '答辩自我介绍模板'
              ],
              url: 'https://www.lingjiang.com/product/3010?type=class',
            },
          ],
        },
        {
          title: '全程套餐班',
          kc: [
            {
              subjectId: '80',
              name: '考评尊享A套餐班',
              price: '17880',
              jdkc: ['督学特训班（2考期）', '精品论文班（2篇）'],
              tsfw: ['高经全程精讲课程', '班主任督学回访', '协议重学', '论文写作指导'],
              xxzl: [
                '期刊推荐发表',
                '题库练习',
                '备考资料包',
                '杂志样刊',
                '查重报告',
              ],
              url: 'https://www.lingjiang.com/product/834?type=package',
            },
            {
              subjectId: '22',
              name: '考评尊享A套餐班',
              price: '17880',
              jdkc: ['督学特训班（2考期）', '精品论文班（2篇）'],
              tsfw: ['高经全程精讲课程', '班主任督学回访', '协议重学', '论文写作指导'],
              xxzl: [
                '期刊推荐发表',
                '题库练习',
                '备考资料包',
                '杂志样刊',
                '查重报告',
              ],
              url: 'https://www.lingjiang.com/product/833?type=package',
            },
            {
              subjectId: '82',
              name: '考评尊享A套餐班',
              price: '17880',
              jdkc: ['督学特训班（2考期）', '精品论文班（2篇）'],
              tsfw: ['高经全程精讲课程', '班主任督学回访', '协议重学', '论文写作指导'],
              xxzl: [
                '期刊推荐发表',
                '题库练习',
                '备考资料包',
                '杂志样刊',
                '查重报告',
              ],
              url: 'https://www.lingjiang.com/product/831?type=package',
            },
            {
              subjectId: '81',
              name: '考评尊享A套餐班',
              price: '17880',
              jdkc: ['督学特训班（2考期）', '精品论文班（2篇）'],
              tsfw: ['高经全程精讲课程', '班主任督学回访', '协议重学', '论文写作指导'],
              xxzl: [
                '期刊推荐发表',
                '题库练习',
                '备考资料包',
                '杂志样刊',
                '查重报告',
              ],
              url: 'https://www.lingjiang.com/product/832?type=package',
            },
            {
              subjectId: '147',
              name: '考评尊享A套餐班',
              price: '17880',
              jdkc: ['督学特训班（2考期）', '精品论文班（2篇）'],
              tsfw: ['高经全程精讲课程', '班主任督学回访', '协议重学', '论文写作指导'],
              xxzl: [
                '期刊推荐发表',
                '题库练习',
                '备考资料包',
                '杂志样刊',
                '查重报告',
              ],
              url: 'https://www.lingjiang.com/product/830?type=package',
            },
            {
              subjectId: '175',
              name: '考评尊享A套餐班',
              price: '17880',
              jdkc: ['督学特训班（2考期）', '精品论文班（2篇）'],
              tsfw: ['高经全程精讲课程', '班主任督学回访', '协议重学', '论文写作指导'],
              xxzl: [
                '期刊推荐发表',
                '题库练习',
                '备考资料包',
                '杂志样刊',
                '查重报告',
              ],
              url: 'https://www.lingjiang.com/product/877?type=package',
            },


            {
              subjectId: '80',
              name: '全程A套餐班',
              price: '26580',
              jdkc: ['督学特训班（2考期）', '精品论文班（2篇）', '评审指导班'],
              tsfw: ['高经全程精讲课程', '班主任督学回访', '协议重学', '论文写作指导', '业绩优化指导', '评审申报指导'],
              xxzl: [
                '业绩优化指导',
                '评审申报指导',
                '章节练习',
                '备考资料包',
                '杂志样刊',
                '查重报告'
              ],
              url: 'https://www.lingjiang.com/product/859?type=package',
            },
            {
              subjectId: '22',
              name: '全程A套餐班',
              price: '26580',
              jdkc: ['督学特训班（2考期）', '精品论文班（2篇）', '评审指导班'],
              tsfw: ['高经全程精讲课程', '班主任督学回访', '协议重学', '论文写作指导', '业绩优化指导', '评审申报指导'],
              xxzl: [
                '业绩优化指导',
                '评审申报指导',
                '章节练习',
                '备考资料包',
                '杂志样刊',
                '查重报告'
              ],
              url: 'https://www.lingjiang.com/product/858?type=package',
            },
            {
              subjectId: '82',
              name: '全程A套餐班',
              price: '26580',
              jdkc: ['督学特训班（2考期）', '精品论文班（2篇）', '评审指导班'],
              tsfw: ['高经全程精讲课程', '班主任督学回访', '协议重学', '论文写作指导', '业绩优化指导', '评审申报指导'],
              xxzl: [
                '业绩优化指导',
                '评审申报指导',
                '章节练习',
                '备考资料包',
                '杂志样刊',
                '查重报告'
              ],
              url: 'https://www.lingjiang.com/product/855?type=package',
            },
            {
              subjectId: '81',
              name: '全程A套餐班',
              price: '26580',
              jdkc: ['督学特训班（2考期）', '精品论文班（2篇）', '评审指导班'],
              tsfw: ['高经全程精讲课程', '班主任督学回访', '协议重学', '论文写作指导', '业绩优化指导', '评审申报指导'],
              xxzl: [
                '业绩优化指导',
                '评审申报指导',
                '章节练习',
                '备考资料包',
                '杂志样刊',
                '查重报告'
              ],
              url: 'https://www.lingjiang.com/product/857?type=package',
            },
            {
              subjectId: '147',
              name: '全程A套餐班',
              price: '26580',
              jdkc: ['督学特训班（2考期）', '精品论文班（2篇）', '评审指导班'],
              tsfw: ['高经全程精讲课程', '班主任督学回访', '协议重学', '论文写作指导', '业绩优化指导', '评审申报指导'],
              xxzl: [
                '业绩优化指导',
                '评审申报指导',
                '章节练习',
                '备考资料包',
                '杂志样刊',
                '查重报告'
              ],
              url: 'https://www.lingjiang.com/product/856?type=package',
            },
            {
              subjectId: '175',
              name: '全程A套餐班',
              price: '26580',
              jdkc: ['督学特训班（2考期）', '精品论文班（2篇）', '评审指导班'],
              tsfw: ['高经全程精讲课程', '班主任督学回访', '协议重学', '论文写作指导', '业绩优化指导', '评审申报指导'],
              xxzl: [
                '业绩优化指导',
                '评审申报指导',
                '章节练习',
                '备考资料包',
                '杂志样刊',
                '查重报告'
              ],
              url: 'https://www.lingjiang.com/product/881?type=package',
            },
          ],
        },
      ],
      kcSubjectId: '80',
      nowDateNum: Date.parse(new Date($.ajax({ async: false }).getResponseHeader("Date"))),
      isWeChat: false,

      btnDisabled1: false,
      btnDisabled2: false,
      btnDisabled3: false,


      bshowReview: true,
      modaldivAppoint: false
    };
  },
  created() {
    this.RegNID = '3107';
    this.projectId = this.getQueryString('projectId') || 38;
    this.ChannelSource = this.getQueryString('ChannelSource');
    if (this.ChannelSource != 1 && this.ChannelSource != 2 && this.ChannelSource != 3 && this.ChannelSource != 4 && this.ChannelSource != 5 && this.ChannelSource != 6 && this.ChannelSource != 7) {
      this.ChannelSource = 4
    }
    if (!this.checkOs().isPc) {
      window.location.href = `./m/index.html?projectId=${this.projectId}&ChannelSource=${this.ChannelSource}`; //跳转到H5版
    }
    // 获取用户信息
    const pageToken = Cookies.get('token') || ''
    this.getUserDetail(pageToken);
  },
  mounted() {
    this.judgeBrowserType();
    this.fnGetScreenSize();
  },
  methods: {
    // 分析图片地址 添加域名信息
    analysisImgUrl(url) {
      if (url) {
        return /^http[s]?:\/\//.test(url) ? url : '//mis1.lingjiang.com' + url
      }
      return headImg
    },
    fnGoReview() {
      window.open('https://www.lingjiang.com/spread/review/2023/topic/index.html#/?Project=38', '_blank')
    },
    checkTime(t1, t2) {
      let time1 = Date.parse(new Date(t1));
      let time2 = Date.parse(new Date(t2));
      if (this.nowDateNum > time2) {
        return 'timeline1';
      } else if (this.nowDateNum < time1) {
        return 'timeline3';
      } else {
        return 'timeline2';
      }
    },
    checkPc() {
      this.showPcTip = true;
    },
    //   浏览器类型
    judgeBrowserType() {
      if (window.navigator.userAgent.indexOf('Firefox') > -1) {
      } else {
        if (window.navigator.userAgent.indexOf('AppleWebKit') != -1) {
        } else {
          this.isShowWebkit = true;
          this.isWebkit = false;
        }
      }
    },
    //屏幕宽高
    fnGetScreenSize() {
      this.screenArry = [screen.width, screen.height];
    },
    // 下载浏览器
    fnDownloadChrome() {
      window.open('https://pc.qq.com/detail/1/detail_2661.html', '_blank')
    },
    // 跳转指定位置
    fnStepCick(id) {
      const anchorElement = document.getElementById(id);
      if (anchorElement) {
        anchorElement.scrollIntoView({
          behavior: 'smooth'
        });
      }
    },
    // 切换场次一
    fnSelectMorningIndex(index) {
      this.selectMorningIndex = index;
    },
    // 切换场次二
    fnSelectAfternoonIndex(index) {
      this.selectAfternoonIndex = index;
    },
    // 获取场次
    getScenesData() {
      const pageToken = Cookies.get('token') || ''
      api
        .getScenesList(code, pageToken)
        .then((res) => {
          if (res && res.data) {
            let result = res.data;
            if (result.length > 0) {
              result.forEach((item) => {
                item.strTime =
                  item.examTime.split('-')[1] +
                  ' ' +
                  item.beginTime.substring(11, item.beginTime.length - 3) +
                  '-' +
                  item.endTime.substring(11, item.beginTime.length - 3);
              });
              this.scencsList = [];
              // 上午场
              let morningSession = result.reduce((arr, el) => {
                if (el.paperTimeType == 1) {
                  arr.push({ ...el });
                }
                return arr;
              }, []);
              // 下午场
              let afternoonSession = result.reduce((arr, el) => {
                if (el.paperTimeType == 2) {
                  arr.push({ ...el });
                }
                return arr;
              }, []);
              this.scencsList = {
                morningSession,
                afternoonSession,
              };
            }
          } else {
            this.$toast.center('网络开小差了，请刷新重试');
          }
        })
        .catch(() => {
          this.$toast.center('网络开小差了，请刷新重试');
        });
    },
    // 立即预约
    fnAppointment(item, type) {
      this.scencsType = type; // 上午 1， 下午 2
      this.selectScensInfo = item;
      if (!this.userId) {
        this.fnShowLogin()
        return;
      }

      let nowDate = Date.parse(new Date($.ajax({ async: false }).getResponseHeader("Date")));
      let endDate = Date.parse(item.endTime.replace(/-/g, '/'));
      if (nowDate > endDate) {
        this.$toast.center('考试已结束');
        return;
      }
      if (item.Appointment) {
        this.$toast.center('您已预约成功');
        return;
      }
      let appointedmentSceneId = ''
      if(this.scencsType == 1) {
        let findResultobj = this.scencsList.afternoonSession.find(item=>item.appointment == true && this.selectScensInfo.subjectName == item.subjectName); // 取消预约的场次ID
        appointedmentSceneId = findResultobj ? findResultobj.sceneId : ''
      } else {
        let findResultobj = this.scencsList.morningSession.find(item=>item.appointment == true && this.selectScensInfo.subjectName == item.subjectName); // 取消预约的场次ID
        appointedmentSceneId = findResultobj ? findResultobj.sceneId : ''
      }
      console.log('appointedmentSceneId===', appointedmentSceneId)
      if(appointedmentSceneId) {
        // 已经预约了上午场，给出提示
        this.modaldiv = true;
        return
      }
      const pageToken = Cookies.get('token') || ''
      api
        .modeltestAppointment(item.sceneId, pageToken)
        .then((res) => {
          if (res) {
            if (res.data.code == 200) {
              this.modaldivAppoint = true
              this.getScenesData();
            } else {
              this.$toast.center(res.data.message);
            }
          } else {
            this.$toast.center('网络开小差了，请稍后重试');
          }
        })
        .catch((err) => {
          if (err && err.response && err.response.status && err.response.status === 401) {
            this.$toast.center('登录失效，请重新登录！');
            this.fnLogout()
            return
          }
          this.$toast.center('网络开小差了，请稍后重试');
        });
    },
    // 重复预约
    fnConfirmAppointment() {
      this.modaldiv = false
      if (this.btnDisabled1) return
      this.btnDisabled1 = true
      const pageToken = Cookies.get('token') || ''
      api
        .modeltestAppointment(this.selectScensInfo.sceneId, pageToken)
        .then((res) => {
          setTimeout(() => {
            this.btnDisabled1 = false
          }, 500);
          if (res) {
            if (res.data.code == 200) {
              this.modaldivAppoint = true
              this.getScenesData();
            } else {
              this.$toast.center(res.data.message);
            }
          } else {
            this.$toast.center('网络开小差了，请稍后重试');
          }
        })
        .catch((err) => {
          setTimeout(() => {
            this.btnDisabled1 = false
          }, 500);
          if (err && err.response && err.response.status && err.response.status === 401) {
            this.$toast.center('登录失效，请重新登录！');
            this.fnLogout()
            return
          }
          this.$toast.center('网络开小差了，请稍后重试');
        });
    },

    // 进入考场
    enterExam(item, index) {
      if (this.btnDisabled2) return
      this.btnDisabled2 = true
      setTimeout(() => {
        this.btnDisabled2 = false
      }, 2000);
      let that = this;
      if (!this.userId) {
        this.fnShowLogin()
        return;
      }

      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        this.isWeChat = true
        return
      }

      let nowDate = Date.parse(new Date($.ajax({ async: false }).getResponseHeader("Date")));
      let endDate = Date.parse(item.endTime.replace(/-/g, '/'));
      if (nowDate > endDate) {
        this.$toast.center('考试已结束！');
        return;
      }
      // 判断是否交卷
      $.ajax({
        url:
          examuserUrl +
          '/Exam/GetExamStatus?UserId=' +
          this.userId +
          '&PapersId=' +
          item.paperId,
        type: 'get',
        async: false,
        dataType: 'jsonp',
        jsonp: 'callback',
        success(res) {
          if (res.success == true) {
            // 未交卷 跳转考场规则页面
            var _t = encodeURI(encodeURI(item.curriculumName));
            window.location =
              './rules/Html/Login.html?userId=' +
              that.userId +
              '&sceneId=' +
              item.sceneId +
              '&papersId=' +
              item.paperId +
              '&culumName=' +
              _t;
          } else {
            that.$toast.center(res.msg);
          }
        },
        error(err) {
          that.$toast.center(err.msg);
        },
      });
    },

    // 答案解析
    checkAnswer(item) {
      if (this.btnDisabled3) return
      this.btnDisabled3 = true
      setTimeout(() => {
        this.btnDisabled3 = false
      }, 2000);
      let that = this;
      if (!this.userId) {
        this.fnShowLogin()
        return;
      }
      let nowDate = Date.parse(new Date($.ajax({ async: false }).getResponseHeader("Date")));
      let endDate = Date.parse('2024/05/26 18:00:00');
      if (nowDate < endDate) {
        this.$toast.center('答案将在5月26日 18:00开放');
        return;
      }

      $.ajax({
        url: examuserUrl + '/Exam/GetExamIdByPUId',
        type: 'get',
        data: {
          UserId: that.userId,
          PapersId: item.paperId,
        },
        async: false,
        dataType: 'jsonp',
        jsonp: 'callback',
        success(res) {
          if (res.success == true) {
            var ExamId = res.DataObj;
            window.location =
              examuserUrl +
              '/exam/explain/pc/index.html?PapersId=' +
              item.paperId +
              '&ExamId=' +
              ExamId +
              '&time=' +
              Math.random();
          } else {
            that.$toast.center(res.msg);
          }
        },
      });
    },

    // 观看直播
    fnLiveClick(url) {
      if (!this.userId) {
        this.fnShowLogin()
        return;
      }
      window.open(url, '_blank')
    },

    livebtnClick(e) {
      this.actindexLivename = e;
    },
    tabclick(e) {
      if(this.kcindex != e) {
        this.kcindex = e;
        this.kcSubjectId = '80'
      }
    },
    // 课程科目切换
    kcSubjectClick(subject){
      this.kcSubjectId = subject.subjectId
    },


    // 登录bengin
    fnShowLogin() {
      this.fnClearCookie()
      this.isShowLogin = true;
      this.checkPhone = '';
      this.checkNum = '';
      this.checkNumText = '获取验证码';
      clearInterval(this.timer);
    },
    hideLogin() {
      clearInterval(this.timer);
      this.isShowLogin = false;
    },
    //获取验证码
    getCheckNum() {
      if (this.logonBtnDisabled1) return
      this.logonBtnDisabled1 = true
      setTimeout(() => {
        this.logonBtnDisabled1 = false
      }, 1000);
      if (this.checkNumText == '获取验证码') {
        if (this.checkUserPhone(this.checkPhone)) {
          let params = {
            phone: this.checkPhone,
            platform: 1, // 1：领匠 2：爱名师 3：评审圈
            verificationCodeType: 1 // 短信类型区分使用的功能 【1：登录 2：忘记密码 3：微信网页授权绑定 4：微信扫码绑定 5：签署协议 6：验证手机号 7：更换绑定的手机号 】
          }
          api.getChecknum(params).then((res) => {
            if (res && res.data && res.data.sendResult) {
              let num = 60;
              this.checkNumText = 60 + ' ' + '秒';
              this.timer = setInterval(() => {
                num--;
                this.checkNumText = num + ' ' + '秒';
                if (num == 0) {
                  clearInterval(this.timer);
                  this.checkNumText = '获取验证码';
                }
              }, 1000);
            } else {
              this.$toast.center('获取验证码失败');
            }
          }).catch(err => {
            this.$toast.center(err.response.data.msg || '获取验证码失败')
          });
        } else {
          if (this.checkPhone == '') {
            this.$toast.center('请输入您的手机号');
          } else {
            this.$toast.center('请输入正确的手机号');
          }
        }
      }
    },
    // 手机号正则验证
    checkUserPhone(str) {
      var reg = /^[1][0-9]{10}$/;
      if (!reg.test(str)) {
        return false;
      } else {
        return true;
      }
    },
    submit() {
      if (this.logonBtnDisabled2) return
      this.logonBtnDisabled2 = true
      setTimeout(() => {
        this.logonBtnDisabled2 = false
      }, 1000);
      if (this.checkUserPhone(this.checkPhone)) {
        if (this.checkNum) {
          this.fnPhoneLogin();
        } else {
          this.$toast.center('请输入验证码');
        }
      } else {
        if (this.checkPhone == '') {
          this.$toast.center('请输入您的手机号');
        } else {
          this.$toast.center('请输入正确的手机号');
        }
      }
    },

    // 验证码登录
    fnPhoneLogin() {
      let parm = {
        phone: this.checkPhone,
        code: this.checkNum,
        source: 2,  // source来源：-1-未知；1-官网；2-活动；3-App；4-小程序
      };
      api.phoneCodeLogin(parm).then((res) => {
        if (res && res.data && res.data.access_token) {
          this.isShowLogin = false;
          // 登录成功 获取用户信息
          this.getUserDetail(res.data.access_token);
          // 登录成功 保存学员登录记录 需要token
          this.fnLoginRecord(2, res.data.access_token)
        } else {
          this.$toast.center('登录失败');
        }
      }).catch(err => {
        this.$toast.center(err.response.data.msg);
      });
    },

    // 获取用户登录信息
    getUserDetail(token) {
      api.getUserInfo(token).then((res) => {
        if (res && res.data && res.data.userId) {
          this.userPhone = res.data.encryptedTelephone;
          this.userId = res.data.userId;
          this.userImg = res.data.avatar;
          this.username = res.data.userName;
          // 登录成功 上报方案
          this.uploadRegistrEvent(res.data.telephone)
          if (token) {
            // 存用户信息，同步支付使用
            Cookies.set('token', token, { expires: 365, path: ' / ', domain: 'lingjiang.com' });
            Cookies.set('access_token', token, { expires: 365, path: ' / ', domain: 'lingjiang.com' });
            let user = {
              userId: res.data.userId,
              userName: res.data.userName,
              headImg: res.data.avatar,
              headImgUrl: res.data.avatar,
              encryptedTelephone: res.data.encryptedTelephone
            };
            Cookies.set('loginUser', encodeURIComponent(JSON.stringify(user)), { expires: 365, path: ' / ', domain: 'lingjiang.com' });
            var str = encodeURIComponent(
              '{"Status":"succ","Data":{"id":' + user.userId + ',"encryptedTelephone":"' + user.encryptedTelephone + '","user_name":"' + user.userName + '","head_img":"' + user.headImgUrl + '","access_token":"' + (token ? token : '') + '"},"ErrorInfo":null,"Message":null}'
            );
            Cookies.set('lJcomcn_UserInfo', str, { expires: 365, path: ' / ', domain: 'lingjiang.com' });
          }
        } else {
          this.userPhone = '';
          this.userId = '';
          this.userImg = '';
          this.username = '';
          this.fnClearCookie()
        }
        this.getScenesData();
      }).catch(err => {
        // 401
        this.userPhone = '';
        this.userId = '';
        this.userImg = '';
        this.username = '';
        this.fnClearCookie()
        this.getScenesData();
      });
    },
    // 清除cookie
    fnClearCookie() {
      Cookies.set('token', '', { expires: 365, path: ' / ', domain: 'lingjiang.com' });
      Cookies.set('access_token', '', { expires: 365, path: ' / ', domain: 'lingjiang.com' });
      Cookies.set('loginUser', '', { expires: 365, path: ' / ', domain: 'lingjiang.com' });
      Cookies.set('lJcomcn_UserInfo', '', { expires: 365, path: ' / ', domain: 'lingjiang.com' });
    },
    // 上报推广方案
    uploadRegistrEvent(phone) {
      let parm = {
        registrationId: this.RegNID,
        phone: phone,
        projectId: this.projectId,
        ChannelSource: this.ChannelSource,
        node: '学员参与了2024年高级经济师模考预约',
      };
      api.uploadRegistrEvent(parm).then((res) => {
        console.log('上报crm', res);
      });
    },
    // 保存学员登录记录
    fnLoginRecord(application, token) {
      api.loginRecord(application, token).then((res) => {
        console.log('保存登录记录==', res);
      });
    },
    // 退出登录
    fnLogout() {
      this.userPhone = '';
      this.userId = '';
      this.userImg = '';
      clearInterval(this.timer);
      this.checkNum = '';
      this.checkPhone = '';
      this.checkNumText = '获取验证码';
      this.fnClearCookie()
      this.getScenesData()
    },
    // 登录end

    // 获取路由参数
    getQueryString(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]);
      return null;
    },
    // 判断浏览器类型
    checkOs() {
      var ua = navigator.userAgent,
        isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
        isPc = !isPhone && !isAndroid && !isSymbian;
      return {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isPc: isPc
      };
    },
    // 头像加载失败
    setDefaultImage(e) {
      e.target.src = 'https://oss.lingjiang.com/webstatic/images/lingjiang/new-default-headimg.png';
    },
    // copy内容
    copyText() {
      var text = document.getElementById("text").innerText;
      var input = document.getElementById("input");
      input.value = text; // 修改文本框的内容
      input.select(); // 选中文本
      document.execCommand("copy"); // 执行浏览器复制命令
      this.$toast.center("复制成功,快去浏览器打开吧")
    },
    // 回到顶部
    fnBackTop() {
      //  设置一个定时器
      const upRoll = setInterval(() => {
        const top = document.documentElement.scrollTop || document.body.scrollTop; // 每次获取页面被卷去的部分
        const speed = top / 10; // 每次滚动多少 （步长值）
        if (document.documentElement.scrollTop !== 0 || document.body.scrollTop !== 0) {
          document.documentElement.scrollTop -= speed;
          document.body.scrollTop -= speed;
          // 不在顶部 每次滚动到的位置
        } else {
          clearInterval(upRoll); // 回到顶部清除定时器
        }
      }, 20);
    },
  },
};
</script>
<style lang="scss">
.index {
  .top {
    width: 100%;
    background: #fff;

    .top-con {
      margin: 0 auto;
      width: 1200px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 65px;
      background: #fff;
    }

    .logo-con {
      display: flex;
      align-items: center;

      .logo {
        margin-right: 12px;
        width: 160px;
      }

      .logo-text {
        width: 150px;
      }
    }

    .top-nav {
      width: 416px;
      display: flex;
      align-items: center;

      .nav-item {
        display: inline-block;
        padding: 4px 10px;
        color: #333;
        margin: 0 20px;
        border-radius: 4px;
        font-size: 18px;
        cursor: pointer;
      }
      .nav-item:hover {
        font-weight: 600;
      }
    }

    .topfont {
      padding-top: 3px;
      display: flex;
      font-size: 18px;

      .login-btn {
        width: 116px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-radius: 20px;
        font-size: 16px;
        background: rgba(224,44,22,.8);
        color: #fff;
        cursor: pointer;
      }

      p {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }

        span {
          margin: 0 16px 0 4px;
        }

        i {
          color: #837f87;
          font-size: 16px;
        }
      }
    }
  }

  .w1200 {
    width: 1200px;
    margin: 0 auto;
    position: relative;
  }

  .com-wth {
    width: 1200px;
    margin: 0 auto;
  }

  .banner {
    min-width: 1200px;
    width: 100%;
    min-height: 900px;
    height: 900px;
    background: url('https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gj/banner.jpg?v=1.3') no-repeat center center;
    background-size: 100% 100%;
    .step-wrap {
      padding-top: 362px;
      .step-con {
        display: flex;
        box-sizing: border-box;
        padding: 30px 30px 30px 30px;
        margin: 0 auto;
        width: 1200px;
        height: 265px;
        border-radius: 20px;
        background: rgba(255, 255, 255, 1);
        .step-item {
          position: relative;
          width: 195px;
          height: 205px;
          margin-right: 30px;
          background: url('https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gj/step_bg.png') no-repeat center center;
          background-size: 100% 100%;
          .step-num {
            position: absolute;
            left: 10px;
            top: 4px;
            font-size: 16px;
            font-weight: 700;
            color: rgba(252, 103, 54, 1);
          }
          .step-title {
            text-align: center;
            font-size: 20px;
            font-weight: 700;
            color: rgba(255, 255, 255, 1);
            line-height: 53px;
          }
          .step-text {
            width: max-content;
            margin: 0 auto;
            margin-top: 10px;
            font-size: 17px;
            font-weight: 400;
            color: rgba(107, 107, 107, 1);
            line-height: 26px;
          }
          .step-btn {
            margin:  0 auto;
            margin-top: 17px;
            width: 150px;
            height: 52px;
            text-align: center;
            line-height: 50px;
            font-size: 17px;
            font-weight: 700;
            color: rgba(255, 255, 255, 1);
            background: url('https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gj/btn-bg.png') no-repeat center center;
            cursor: pointer;
            transition: .4s;
          }
          .step-btn2 {
            margin-top: 40px;
          }

          .step-btn:hover {
            transform: translateY(-3px);
          }
        }
        .step-live-bg {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 240px;
          height: 205px;
          background: url('https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gj/step_zb_bg.png') no-repeat center center;
          border-radius: 20px;
          img {
            margin: 13px 0 10px 0;
            width: 120px;
            height: 120px;
          }
          span {
            text-align: center;
            font-size: 16px;
            font-weight: 700;
            line-height: 22.52px;
            color: rgba(56, 56, 56, 1);
          }
        }
      }
    }
  }

  .maintitle {
    font-weight: bold;
    font-size: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    margin-top: 30px;
    margin-bottom: 20px;
    color: rgba(255, 255, 255, 1);

    img {
      width: 91px;
      height: 25px;
      margin-left: 20px;
      margin-right: 20px;
      margin-top: 6px;
    }
  }

  .maintitle2 {
    color: #fff;
    padding-top: 30px;
  }

  .ksap {
    width: 1200px;
    margin: 30px auto;
    height: 400px;
    background: #ffffff;
    box-shadow: 0px 0px 20px 0px rgba(153, 153, 153, 0.15);
    border-radius: 20px;
    .ksaptop {
      height: 90px;
      display: flex;
      align-items: center;
      .tags {
        span {
          position: relative;
          margin: 0 26px;
          font-size: 20px;
          color: #000003;
          float: left;
          cursor: pointer;
          .line {
            position: absolute;
            bottom: -8px;
            left: 50%;
            margin-left: -19px;
            width: 38px;
            border-bottom: 2px solid rgba(176, 25, 40, 1);
          }
        }
        .activeTag {
          color: rgba(176, 25, 40, 1);
        }
      }
      .ksaptoptag {
        margin-right: 28px;
        width: 251px;
        height: 90px;
        background: linear-gradient(90deg, rgba(176, 25, 40, 1) 0%, rgba(255, 84, 82, 1) 100%);
        border-radius: 20px 0px 50px 0px;
        color: #fff;
        text-align: center;
        font-size: 16px;
        .ksaptitle {
          font-size: 30px;
          font-weight: bold;
          padding-top: 10px;
          padding-bottom: 5px;
        }
      }
      .ksaptip {
        font-size: 20px;
        flex: 1;
        background: url(../assets/icon.png) left center no-repeat;
        padding-left: 40px;
        line-height: 90px;
      }
    }
    .pad30 {
      padding: 30px;
    }
    .ksapbg {
      height: 250px;
      background: url(https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gj/mokaobg.png)
        no-repeat;
      padding: 26px 30px 30px 30px;
      box-sizing: border-box;
      position: relative;
      .mktitle {
        margin-bottom: 10px;
        height: 40px;
        line-height: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .mktitlefont {
          font-size: 24px;
          font-weight: bold;
          float: left;
        }
      }
      .mkicon {
        display: flex;
        justify-content: space-between;
        align-items: center;
        ul {
          font-size: 16px;
          overflow: hidden;
        }
        li {
          background: url(../assets/ok.png) no-repeat left center;
          padding-left: 28px;
          height: 30px;
          line-height: 30px;
          float: left;
          margin-right: 25px;
        }
      }
      .mkdesc {
        color: #666;
        font-size: 18px;
        line-height: 36px;
        margin-top: 18px;
      }
      .mkstatus {
        position: absolute;
        bottom: 83px;
        left: 702px;
      }
      .enterbtn {
        position: absolute;
        bottom: 146px;
        right: 30px;
        text-align: center;
        font-size: 17px;
        color: #ffffff;
        width: 150px;
        height: 50px;
        line-height: 48px;
        background: url(https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gj/btn-bg.png) no-repeat center center;
        border-radius: 25px;
      }
      .lookbtn {
        position: absolute;
        bottom: 80px;
        right: 30px;
        text-align: center;
        font-size: 17px;
        color: #ffffff;
        width: 150px;
        height: 50px;
        line-height: 50px;
        background: linear-gradient(180deg, rgba(91, 199, 255, 1) 0%, rgba(46, 149, 250, 1) 100%);
        border-radius: 25px;
      }
    }
  }


  .ksap-remark {
    box-sizing: border-box;
    margin: 0 auto;
    margin-top: -10px;
    position: relative;
    padding: 12px 30px;
    width: 1200px;
    height: 163px;
    border-radius: 20px;
    background: rgba(255, 255, 255, 1);

    .title {
      font-size: 24px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
    }
    .remark-text {
      margin-top: 10px;
      line-height: 24px;
      color: rgba(51, 51, 51, 1);
      font-size: 18px;
      font-weight: 400;
      span {
        color: #0188f0;
        text-decoration: underline;
        cursor: pointer;
      }
    }
    img {
      position: absolute;
      top: 0;
      right: 47px;
      width: 153px;
      height: 165px;
    }
  }

  .f18 {
    font-size: 18px;
  }

  .f24 {
    font-size: 24px;
  }

  a.blue {
    color: #0c29b0;
    text-decoration: underline;
  }

  .lin30 {
    line-height: 30px;
  }

  .livebg {
    height: 594px;
    .live {
      background: url('https://oss.lingjiang.com/webstatic/questionbank/images/mock-exam/2023/gjjjs/livebg.png') right bottom no-repeat;
      margin-top: 22px;
      .liveplay {
        margin-left: 20px;
        width: 800px;
        height: 450px;
        text-align: center;
        color: #fff;
        border-radius: 20px;
        position: relative;
        overflow: hidden;
        animation: movedh 2s;
        .livemain {
          width: 800px;
          height: 450px;
          padding-top: 100px;
          background: rgba(0, 0, 0, 0.4);
          position: absolute;
          left: 0px;
          top: 0px;
          box-sizing: border-box;
          // display: none;
          .livetitle {
            font-size: 34px;
            font-weight: bold;
            text-align: center;
          }
          .livedesc {
            font-size: 24px;
            line-height: 40px;
            margin-top: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            div {
              display: flex;
              flex-direction: column;
              text-align: left;
            }
          }
          .looklive {
            width: 200px;
            height: 60px;
            line-height: 60px;
            background: linear-gradient(90deg, #ffbf63 0%, #ff9f17 100%);
            border-radius: 30px;
            text-align: center;
            margin: 30px auto;
            display: block;
            color: #fff;
            font-size: 24px;
          }
        }
      }
      .liveplay:hover {
        .livemain {
          display: block;
        }
      }
      .livebtn li {
        width: 200px;
        height: 70px;
        line-height: 70px;
        border: 1px solid #ff9f16;
        border-radius: 35px;
        float: left;
        margin-right: 38px;
        margin-top: 25px;
        cursor: pointer;
        text-align: center;
        color: #ff9f16;
        font-size: 28px;
      }
      .livebtn li.hov {
        color: #fff;
        background: linear-gradient(-90deg, #ff9e15 0%, #ffbf65 100%);
      }
      .ewm {
        position: absolute;
        right: 0px;
        top: 86px;
        width: 380px;
        text-align: center;
        font-size: 20px;
        color: #333333;
        font-weight: 600;
        img {
          width: 210px;
          height: 210px;
          margin-bottom: 18px;
        }
      }
    }
  }
  .tabs {
    padding-left: 7px;
    margin-top: 30px;
  }
  .tabs span.active {
    font-weight: 600;
    background: linear-gradient(180deg, rgba(255, 191, 99, 1) 0%, rgba(255, 159, 23, 1) 100%);
  }
  .tabs span {
    margin-left: 13px;
    display: inline-block;
    width: 151px;
    height: 60px;
    border-radius: 20px 20px 0px 0px;
    background: linear-gradient(90deg, rgba(176, 25, 40, 1) 0%, rgba(255, 84, 82, 1) 100%);
    text-align: center;
    line-height: 60px;
    font-size: 20px;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    cursor: pointer;
  }
  .bluebg {
    background: #fff;
    border-radius: 20px;
    padding: 20px;
    padding-bottom: 15px;
    .kcSubject {
      display: flex;
      p {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        margin-bottom: 20px;
        margin-right: 16px;
        width: 145px;
        height: 40px;
        border-radius: 7px;
        background: rgba(255, 243, 240, 1);
        font-size: 16px;
        font-weight: 400;
        color: rgba(56, 56, 56, 1);
        text-align: center;
        line-height: 40px;
        border: 1px solid rgba(255, 230, 216, 1);
        cursor: pointer;
      }
      .active {
        font-weight: 600;
        background: linear-gradient(90deg, rgba(255, 191, 99, 1) 0%, rgba(255, 159, 23, 1) 100%);
        color: #fff;
      }
    }
  }
  .kcmain {
    background: rgba(255, 242, 238, 1);
    border-radius: 16px;
    height: 360px;
    position: relative;
    padding-top: 24px;
    box-sizing: border-box;
    margin-bottom: 25px;
  }
  .kcname {
    width: 80px;
    height: 300px;
    background: rgba(255, 190, 139, 1);
    border-radius: 0px 19.33px 19.33px 0px;
    font-size: 24px;
    color: rgba(68, 31, 5, 1);
    font-weight: bold;
    padding: 25px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    position: absolute;
    left: 0px;
    top: 31px;
  }
  .kcbuy {
    margin-top: 34px;
    background: url(https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gk/kcbg.png) no-repeat;
    width: 266px;
    height: 315px;
    margin-left: 122px;
    position: relative;
    float: left;
  }
  .price {
    position: relative;
    color: rgba(244, 96, 88, 1);
    font-size: 22px;
    padding-top: 32px;
    text-align: center;

    strong {
      font-size: 35px;
    }
  }
  .buybtn {
    width: 212.67px;
    height: 48.33px;
    line-height: 49px;
    background: linear-gradient(180deg, rgba(240, 85, 77, 1) 0%, rgba(253, 120, 112, 1) 100%);
    color: rgba(255, 255, 255, 1);
    border-radius: 96.67px;
    text-align: center;
    font-size: 19.33px;
    display: block;
    position: absolute;
    left: 27px;
    top: 97px;
    transition: .4s;
  }
  .buybtn:hover {
    transform: translateY(-3px);
  }

  .kcright {
    display: flex;
    float: right;
    margin-right: 30px;
  }

  .kcdiv1,
  .kcdiv2,
  .kcdiv3 {
    width: 220px;
    border: 1px solid #ebebeb;
    height: 310px;
  }

  .kcdiv1 {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }

  .kcdiv3 {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .kcdiv2 {
    border-left: 0px;
    border-right: 0px;
  }

  .kctitle {
    border-bottom: 1px solid #ebebeb;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    height: 50px;
    line-height: 50px;
  }

  .kcright ul {
    padding: 20px;
    padding-right: 0px;
  }

  .kcright li {
    background: url('https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gk/kcicon.jpg') left center no-repeat;
    background-size: 15px 15px;
    padding-left: 23px;
    font-size: 16px;
    height: 30px;
    line-height: 30px;
  }


  .flex-between {
    justify-content: space-between;
  }

  .flex {
    display: flex;
  }

  .transition4 {
    transition: .4s;
  }
  .transition4:hover {
    transform: translateY(-3px);
  }



  //弹窗
  .mask {
    background: rgba(0, 0, 0, 0.7);
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;

    .modalcen {
      width: 550px;
      position: relative;
      padding: 30px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 20px;

      .modalicon {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        background: #fff;
        position: absolute;
        left: 50%;
        margin-left: -40px;
        top: -40px;
        text-align: center;
        box-sizing: border-box;
        padding-top: 15px;

        img {
          width: 40px;
        }
      }

      .modaltitle {
        text-align: center;
        font-size: 26px;
        padding-top: 20px;
        color: #223eb5;
        font-weight: bold;
      }

      .modalfont {
        font-size: 20px;
        line-height: 34px;
        margin-top: 20px;
      }

      .modalbtngroup {
        cursor: pointer;
        margin-top: 30px;
        margin-left: auto;
        margin-right: auto;
        width: 150px;
        height: 50px;
        border: 1px solid #142caa;
        border-radius: 25px;
        text-align: center;
        color: #ffffff;
        line-height: 50px;
        background: linear-gradient(117deg, #142caa, #3557c4);
        font-size: 22px;
      }

      .modalbtngroup2 {
        padding: 0 0.35rem;
        overflow: hidden;
        margin-top: 0.5333rem;

        .modalbtn1 {
          width: 2.1rem;
          float: left;
          height: 0.7rem;
          border: 0.0133rem solid #142caa;
          border-radius: 0.4667rem;
          text-align: center;
          color: #142caa;
          line-height: 0.7rem;
          font-size: 0.36rem;
          cursor: pointer;
        }

        .modalbtn2 {
          width: 2.1rem;
          float: right;
          height: 0.7rem;
          border: 0.0133rem solid #142caa;
          border-radius: 0.4667rem;
          text-align: center;
          color: #142caa;
          line-height: 0.7rem;
          font-size: 0.36rem;
          cursor: pointer;
        }
      }

      .fexdiv {
        display: flex;
        align-items: flex-start;

        img {
          margin-right: 10px;
          margin-top: 2px;
        }
      }

      .modaltip {
        color: #666;
        font-size: 16px;
      }
    }
    .modalcen2 {
      width: 423px;
      .modalbtngroup2 {
        padding: 0 0.35rem;
        overflow: hidden;
        margin-top: 0.5333rem;

        .modalbtn1 {
          width: 1.6rem;
          float: left;
          height: 0.55rem;
          border: 0.0133rem solid #142caa;
          border-radius: 0.4667rem;
          text-align: center;
          color: #142caa;
          line-height: 0.55rem;
          font-size: 20px;
          cursor: pointer;
        }

        .modalbtn2 {
          width: 1.6rem;
          float: right;
          height: 0.55rem;
          border: 0.0133rem solid #142caa;
          border-radius: 0.4667rem;
          text-align: center;
          color: #142caa;
          line-height: 0.55rem;
          font-size: 20px;
          cursor: pointer;
        }
      }
    }
    .modalcen3 {
      width: 400px;
      .modalfont-flex {
        display: flex;
        justify-content: center;
        align-items: center;
        .live-ewm {
          margin-right: 20px;
          width: 150px;
        }
        .modalfont-text {
          font-size: 16px;
          display: flex;
          flex-direction: column;
          align-items: center;
          line-height: 26px;
        }
      }
      .modalbtngroup3 {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        .modalbtn1 {
          width: 1.6rem;
          height: 0.55rem;
          border: 0.0133rem solid #142caa;
          border-radius: 0.4667rem;
          text-align: center;
          color: #142caa;
          line-height: 0.55rem;
          font-size: 20px;
          cursor: pointer;
        }
      }
    }
  }

  .wxTips {
    margin-bottom: 56px;
    font-size: 18px;
    font-weight: 800;

    .linkInfo {
      margin-top: 20px;

      span:nth-child(1) {
        color: #2f50c0;
      }

      span:nth-child(2) {
        margin-left: 16px;
        padding: 5px 10px;
        color: #2f50c0;
        border: 1px solid #2f50c0;
        border-radius: 6px;
        cursor: pointer;
      }
    }
  }

  .fukuang {
    width: 80px;
    height: 280px;
    background: linear-gradient(180deg, rgba(247, 182, 80, 1) 0%, rgba(250, 145, 18, 1) 100%);
    border-radius: 10px;
    position: fixed;
    right: 10px;
    top: 50%;
    margin-top: -200px;
    z-index: 12;
  }

  .fukuang a {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    width: 80px;
    height: 70px;
    border-radius: 10px;
    font-size: 13px;
    margin-bottom: 15px;
    position: relative;
  }

  .fukuang a img {
    display: block;
  }

  .fukuang a p {
    line-height: 25px;
    margin: 0;
    padding: 0;
    text-align: center;
  }

  .fukuang a .zixunhover {
    display: none;
    width: 156px;
    position: absolute;
    background: #fff;
    left: -160px;
    bottom: 0;
    font-size: 14px;
    color: #666;
    line-height: 120%;
    flex-direction: column;
    text-align: center;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
    padding: 10px 0;
    div {
      line-height: 20px;
    }
  }

  .fukuang a .zixunhover1 {
    line-height: 20px;
    padding: 14px 10px;
    left: -180px;
    img {
      margin: 4px;
    }
  }

  .fukuang a .zixunhover img {
    margin-bottom: 5px;
    // margin-left: 9px;
    display: block;
  }

  .fukuang a:hover {
    background: -webkit-gradient(linear,
        left bottom,
        left top,
        from(#f55228),
        to(#f7623f));
    background: linear-gradient(0deg, #f55228 0%, #f7623f 100%);
  }

  .fukuang .help {
    background: -webkit-gradient(linear,
        left bottom,
        left top,
        from(#f55228),
        to(#f7623f));
    background: linear-gradient(0deg, #f55228 0%, #f7623f 100%);
  }

  .fukuang .help:hover {
    background: -webkit-gradient(linear,
        left bottom,
        left top,
        from(#fb8e0d),
        to(#f7b854));
    background: linear-gradient(0deg, #fb8e0d 0%, #f7b854 100%);
  }

  .fukuang .help .zixunhover {
    background: none;
    border: none;
    width: 222px;
    left: -200px;
    bottom: -80px;
    padding-right: 50px;
  }

  .fukuang .help .zixunhover2 {
    display: block;
    padding: 20px 20px 60px 20px;
    border: 1px solid #e5e5e5;
    background: #fff;
    border-radius: 5px;
    margin-right: 26px;

    span {
      display: block;
      text-align: left;
    }

    .help-title {
      display: flex;
      justify-content: center;
      align-items: center;
      color: red;
      font-weight: 800;
      font-size: 20px;
      margin-bottom: 14px;

      i {
        font-style: normal;
      }

      .wen {
        width: 22px;
        height: 22px;
        margin-left: 6px;
        text-align: center;
        line-height: 22px;
        color: #fff;
        background: red;
        border-radius: 50%;
        font-size: 18px;
      }
    }

    .download {
      text-decoration: underline;
      color: #0a0aff;
      font-size: 16px;
      font-weight: 600;
      margin-top: 30px;
    }
  }

  .fukuang .help:hover>.zixunhover {
    display: block;
  }

  .fukuang a:hover>.zixunhover {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }

  .fukuang .line {
    position: absolute;
    bottom: -5px;
    width: 60px;
    border-top: 1px solid rgba(242, 193, 107, 1);
  }
  .fukuang .back-top {
    padding-top: 5px;
    margin: 0 auto;
    margin-top: -10px;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    cursor: pointer;
  }

  .review {
    position: fixed;
    bottom: 120px;
    left: 30px;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    img {
      cursor: pointer;
    }
    .review-bg {
      width: 142px;
    }
    .review-btn {
      margin-top: -10px;
      width: 110px;
      -webkit-animation-name: xing;
      -webkit-animation-timing-function: ease-in-out;
      -webkit-animation-iteration-count: infinite;
      -webkit-animation-duration: 2.5s;
    }
    .close-review-img {
      width: 25px;
      position: absolute;
      top: 1px;
      right: 1px;
    }
  }
  @keyframes xing {
    0% {
      transform: scale(1);
    }

    25% {
      transform: scale(1.07);
    }

    50% {
      transform: scale(1);
    }

    75% {
      transform: scale(1.07);
    }
  }
}

/* 登录bengin */
.login {
  position: relative;
  width: 450px;
  height: 440px;
  padding: 35px;
  background: #ffffff;
  box-sizing: border-box;

  .login-title {
    font-size: 24px;
    color: #333;
    font-weight: bold;
  }


  .login-form-main-con {
    position: relative;
    margin-top: 48px;
    margin-bottom: 35px;

    .form-item {
      width: 100%;
      height: auto;

      input {
        width: 100%;
        line-height: 48px;
        border: 1px solid #d0d6d9;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
        font-size: 18px;
        padding-left: 26px;
        box-sizing: border-box;
      }

      .phone {
        overflow: hidden;
        border: 1px solid #d0d6d9;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);

        input {
          border: none;
        }
      }
    }


    .code {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 35px;

      input {
        width: 250px;
        border-right: transparent;
      }

      .checkNumBtn {
        cursor: pointer;
        flex: 1;
        height: 52px;
        line-height: 52px;
        text-align: center;
        color: #fff;
        background: rgba(224,44,22,.8);
        font-size: 14px;
      }
    }
  }

  .tips {
    font-size: 14px;
    color: #333;
  }

  .login-btn {
    display: block;
    line-height: 60px;
    text-align: center;
    background: rgba(224,44,22,.8);
    border-radius: 4px;
    font-size: 20px;
    color: #fff;
    margin-top: 45px;
    cursor: pointer;
  }

  .close-btn {
    position: absolute;
    display: block;
    width: 32px;
    height: 32px;
    right: -16px;
    top: -16px;
    border-radius: 32px;
    cursor: pointer;
    background: #fff;
  }
}

input:focus {
  outline: none;
}

/* 登录end */
.logout {
  font-style: normal;
  cursor: pointer;
  font-size: 18px;
}

@keyframes movedh {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue